<template>
  <div>
    <div class="message" v-if="getBet.odds.length == 0">
      <span class="title">{{ $t('noOddsSelected') }}</span
      ><br />
      <span class="subTitle">{{ $t('pleaseSelectOdd') }}</span>
    </div>
    <div class="cartOverflowForActionButtonFixed" v-else>
      <!--      :style="(getUseModalCart === true && getHeightOfParentIframe) ? 'overflow-y:scroll; height: calc('+ getHeightOfParentIframe+'px - 75px - 75px - 48px)': ''"-->

      <BetTypeSelectorMarketView></BetTypeSelectorMarketView>
      <BetOddsSummaryMarketView
        :style="
          getUseModalCart === true && getHeightOfParentIframe
            ? 'height: ' + heightSummaryOdds
            : ''
        "
      ></BetOddsSummaryMarketView>

      <v-progress-linear
        indeterminate
        color="primary darken-2"
        v-if="getLoading"
      ></v-progress-linear>
    </div>

    <div
      class="summary-footer-for-modal-cart"
      v-if="getBet.odds.length > 0"
      ref="SummaryFooterForModalCart"
    >
      <section v-if="getBet.type == 'single' || getBet.type == 'multiple'">
        <SummarySingleMultiple></SummarySingleMultiple>
      </section>
      <section v-else-if="getBet.type == 'integral'">
        <SummaryIntegral></SummaryIntegral>
      </section>
      <section v-else-if="getBet.type == 'system'">
        <SummarySystem></SummarySystem>
      </section>
      <Errors></Errors>
      <Warnings></Warnings>
      <ActionsMarketView></ActionsMarketView>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BetTypeSelectorMarketView from '@/components/right_widgets/BetTypeSelectorMarketView'
import BetOddsSummary from '@/components/right_widgets/BetOddsSummary'
import BetOddsSummaryMarketView from '@/components/right_widgets/BetOddsSummaryMarketView'
import SummarySingleMultiple from '@/components/right_widgets/SummarySingleMultiple'
import SummaryIntegral from '@/components/right_widgets/SummaryIntegral'
import SummarySystem from '@/components/right_widgets/SummarySystem'
import ActionsMarketView from '@/components/right_widgets/ActionsMarketView'
import Errors from '@/components/right_widgets/Errors'
import Warnings from '@/components/right_widgets/Warnings'
import { EventBus } from '@/plugins/eventBus'
import { checkIsMobileDevice } from '@/plugins/device-inspector'

export default {
  name: 'BetSlip',
  components: {
    Warnings,
    ActionsMarketView,
    Errors,
    SummarySystem,
    SummaryIntegral,
    SummarySingleMultiple,
    BetOddsSummaryMarketView,
    BetTypeSelectorMarketView,
  },
  data: () => ({
    heightSummaryOdds: 'initial',
  }),
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getBet: 'cart/getBet',
      getSettings: 'cart/getSettings',
      getLoading: 'cart/getLoading',
      getHeightOfParentIframe: 'settings/getHeightOfParentIframe',
      getUseModalCart: 'uiConfig/useModalCart',
      getIsCartOpen: 'cart/getIsCartOpen',
    }),
  },
  methods: {
    ...mapActions({
      setLoadingCart: 'cart/setLoadingCart',
      refreshCart: 'cart/refreshCart',
      initCart: 'cart/initCart',
      setBetType: 'cart/setBetType',
      setSystemComboDetail: 'cart/setSystemComboDetail',
    }),
    checkIsMobile() {
      return checkIsMobileDevice()
    },

    getHeightOfSummary() {
      const vm = this

      console.log('refreshedCartWithOdd')
      console.log('odds', this.getBet.odds.length)
      if (!vm.checkIsMobile()) {
        if (this.getBet.odds.length) {
          const cartHeaderHeight =
            document.getElementById('cartHeader').offsetHeight
          const betTypeSelectorHeight =
            document.getElementById('BetTypeSelector').offsetHeight
          // console.log("cartHeaderHeight", cartHeaderHeight)
          // console.log("betTypeSelectorHeight", betTypeSelectorHeight)
          // console.log("SummaryFooterForModalCart", vm.$refs.SummaryFooterForModalCart.offsetHeight)

          if (vm.$refs.SummaryFooterForModalCart) {
            if (cartHeaderHeight && betTypeSelectorHeight) {
              vm.heightSummaryOdds =
                vm.getHeightOfParentIframe -
                vm.$refs.SummaryFooterForModalCart.offsetHeight -
                cartHeaderHeight -
                betTypeSelectorHeight +
                'px'
            }
          }
        }
      }
    },
  },
  watch: {
    getHeightOfParentIframe(height) {
      console.log('watch getHeightOfParentIframe', height)
    },
  },
  async mounted() {
    const vm = this
    this.getBet.system_parts = []
    this.getBet._system_detail.amount_system_to_divide = null
    this.getBet._system_detail.amount_system_equal = null
    this.getBet._system_detail.amount_system = 0.0
    this.getBet._system_detail.fixed_bases = []
    // await this.refreshCart()
    await this.initCart()

    console.log('this.getHeightOfParentIframe', this.getHeightOfParentIframe)

    if (this.getUseModalCart === true) {
      EventBus.$on('refreshedCartWithOdd', this.getHeightOfSummary)
    }
  },
  beforeDestroy() {
    if (this.getUseModalCart === true) {
      EventBus.$off('refreshedCartWithOdd', this.getHeightOfSummary)
    }
  },
}
</script>
